import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"

export default () => (
  <StaticQuery
    query={graphql`
      query MenuQuery {
        wpgraphql {
          menuItems(where: { location: MOBILE }) {
            edges {
              node {
                label
                url
                connectedObject {
                  ... on WPGraphQL_Post {
                    slug
                    title
                  }
                  ... on WPGraphQL_MenuItem {
                    title
                  }
                  ... on WPGraphQL_Tag {
                    slug
                    name
                  }
                  ... on WPGraphQL_Category {
                    slug
                    name
                  }
                  ... on WPGraphQL_Page {
                    slug
                    title
                  }
                }
                childItems {
                  edges {
                    node {
                      label
                      url
                      connectedObject {
                        ... on WPGraphQL_Post {
                          slug
                          title
                        }
                        ... on WPGraphQL_MenuItem {
                          title
                        }
                        ... on WPGraphQL_Tag {
                          slug
                          name
                        }
                        ... on WPGraphQL_Category {
                          slug
                          name
                        }
                        ... on WPGraphQL_Page {
                          slug
                          title
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <nav>
        <ul className="flex flex-col lg:flex-row">
          {" "}
          {data.wpgraphql.menuItems.edges.map(({ node }) => (
            <li key={node.id}>
              {" "}
              {"#" !== node.url ? (
                <Link
                  className="p-1 lg:p-4"
                  to={`/${node.connectedObject.slug}`}
                >
                  {" "}
                  {node.label}{" "}
                </Link>
              ) : (
                <div> {node.label} </div>
              )}{" "}
              {node.childItems.edges.length > 0 && (
                <ul className="sub-nav">
                  {" "}
                  {node.childItems.edges.map(({ node }) => (
                    <li key={node.id}>
                      <Link
                        className="p-1 lg:p-2"
                        to={`${node.connectedObject.slug}`}
                      >
                        {" "}
                        {node.label}{" "}
                      </Link>{" "}
                    </li>
                  ))}{" "}
                </ul>
              )}{" "}
            </li>
          ))}{" "}
          <li>
            <Link className="p-1 lg:p-4" to={`/category/news`}>
              News
            </Link>
          </li>
        </ul>{" "}
      </nav>
    )}
  />
)
